import { render, staticRenderFns } from "./MagicMap.vue?vue&type=template&id=6fc935d8&scoped=true&"
import script from "./MagicMap.vue?vue&type=script&lang=js&"
export * from "./MagicMap.vue?vue&type=script&lang=js&"
import style0 from "./MagicMap.vue?vue&type=style&index=0&id=6fc935d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc935d8",
  null
  
)

export default component.exports